/* src/app/pages/analysis-details/analysis-details.component.scss */
.center {
  width: 25%;
  margin: 10px auto;
}
.main-div {
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.nolist {
  list-style: none;
}
/*# sourceMappingURL=analysis-details.component.css.map */
